// @mui material components
import Container from "@mui/material/Container";
import Icon from "@mui/material/Icon";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";
import SEO from "components/SEO";

// Material Kit 2 React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

function NotFound() {
  return (
    <>
      <SEO noindex title="Page Not Found" path="/404" />
      <DefaultNavbar routes={routes} sticky />
      <MKBox
        minHeight="70vh"
        width="100%"
        variant="gradient"
        bgColor="info"
        sx={{ display: "grid", placeItems: "center" }}
      >
        <Container>
          <MKBox textAlign="center" color="white">
            <MKTypography variant="h1" color="white" sx={{ fontSize: { xs: "4rem", md: "6rem" } }}>
              404
            </MKTypography>
            <MKTypography variant="h3" color="white" mb={1}>
              Page not found
            </MKTypography>
            <MKTypography variant="body1" color="white" opacity={0.8} mb={3}>
              The page you are looking for doesn&apos;t exist or has moved.
            </MKTypography>
            <MKButton variant="gradient" color="light" component="a" href="/">
              <Icon sx={{ mr: 1 }}>home</Icon>
              Back to home
            </MKButton>
          </MKBox>
        </Container>
      </MKBox>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default NotFound;
